export const ActionOptions = [
    {
        key: 0,
        text: "Add",
        value: "add"
    },
    {
        key: 1,
        text: "Edit",
        value: "edit"
    },
    {
        key: 2,
        text: "Delete",
        value: "delete"
    }
]
